/**
 * Divide two numbers
 *
 * Returns 0, if `b` is 0
 */
export default function div(a: number, b: number) {
  return b === 0 ? 0 : a / b;
}
